import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ThemeProvider } from '../contexts/ThemeContext';
import Header from './Header';
import TaskAnalyticsChat from './TaskAnalyticsChat';
import './AIAssistant.css';

const AIAssistant: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToTasks = () => {
    navigate('/app');
  };

  return (
    <ThemeProvider>
      <div className="app full-width">
        <Header onNewTask={handleBackToTasks} />
        
        <main className="main-content">
          <div className="container">
            <div className="ai-assistant-page">
              <div className="ai-assistant-header">
                <h2>🤖 AI Task Assistant</h2>
                <p>Rozmawiaj z AI o swoich zadaniach, analizuj wzorce i znajdź problemy w projektach</p>
              </div>
              
              <div className="ai-assistant-content">
                <TaskAnalyticsChat />
              </div>
            </div>
          </div>
        </main>
      </div>
    </ThemeProvider>
  );
};

export default AIAssistant; 